<template>
  <div>
    <script id="editor" type="text/plain" ></script>
  </div>
</template>

<script>
  import '../../static/Ueditor/ueditor.config.js'
  import '../../static/Ueditor/ueditor.all.js'
  import '../../static/Ueditor/lang/zh-cn/zh-cn.js'
  // import '../../static/Ueditor/jquery-2.2.3.min.js'

  export default {
    name: "UEditor",
    props: {
      id: {
          type: String
      },
      config: {
          type: Object
      },
      value: {
        type: String,
        default: null
      }
    },
    data() {
      return {
        editor: null
      }
    },
    mounted() {
      //初始化UE
      this.$nextTick(function f1() {
                // 保证 this.$el 已经插入文档
        this.editor = UE.delEditor("editor");
        this.editor = UE.getEditor('editor', this.config)
        this.editor.ready(function f2() {
          this.editor.setContent(this.value)
          this.editor.addListener("contentChange", function () {
            const wordCount = this.editor.getContentLength(true)
            const content = this.editor.getContent()
            const plainTxt = this.editor.getPlainTxt()
            const htmlCont = this.editor.getAllHtml()
            // 编辑器内容有变动,通知父组件
            this.$emit('input', { wordCount: wordCount, content: content, plainTxt: plainTxt ,htmlCont:htmlCont });
          }.bind(this))
          // editor初始化后操作
          this.$emit('ready', this.editor)
        }.bind(this))
      })
    },
    watch: {
      'value': function (val) {
        this.editor.getContent(val)
      }
    },
    destoryed() {
      this.editor.destory();
    },
    methods:{
      resetContent () {
        this.editor.setContent('')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/layout/ueditor.vue